import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  coderCard:{
    codeHistoryCard: false,
    codeAssistWindowCard: true,
    codeBookCard: true,
    nudgingCard: false,
  }
};

const codeAssistSlicer = createSlice({
  name: "codeAssistSlicer",
  initialState,
  reducers: {
    setCodeHistoryCard: (state, action) => {
        state.coderCard.codeHistoryCard = action.payload;
    },
    setCodeAssistWindowCard: (state, action) => {
        state.coderCard. codeAssistWindowCard = action.payload;
    },
    setCodeBookCard: (state, action) => {
        state.coderCard.codeBookCard = action.payload;
    },
    setNudgingCard: (state, action) => {
      state.nudgingCard = action.payload;
    },
  },
});
export const { setCodeHistoryCard,   setCodeAssistWindowCard, setCodeBookCard,setNudgingCard } = codeAssistSlicer.actions;

export default codeAssistSlicer.reducer